import React from 'react';
import styles from './LayoutHorizontalTwo.module.css';

const Layout=(props)=>{
	const layoutClass = props.layout3 === true ? `${styles.layout} ${styles.layout3}` : `${styles.layout}`;
	return (
		
		<div className={layoutClass}>
			{props.children.map((elem,index)=>(
				<div key={index} className={styles.outer_wrap} style={{msGridRow:1,msGridColumn:index+1}}>
					<div className={styles.inner_wrap}>
						{elem}
					</div>
				</div>
			))}
		</div>
	);
}

export default Layout;